<template>
  <span
    class="inline-flex items-center gap-0.5"
    :class="{
      'text-th-green': tone === 'up',
      'text-th-red': tone === 'down',
      'text-th-secondary-gray': tone === 'neutral' || tone === 'none'
    }"
  >
    <template v-if="hasArrow">
      <caret-top-icon
        v-if="tone === 'up'"
        class="w-3 h-3"
        data-testid="diff-badge-arrow-up"
      />
      <caret-bottom-icon
        v-else-if="tone === 'down'"
        class="w-3 h-3"
        data-testid="diff-badge-arrow-down"
      />
    </template>
    {{ tone === 'none' ? t('components.diff_badge.none') : `${diff}%` }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { CaretBottomIcon, CaretTopIcon } from '@shared/assets/icons'

type DiffTone = 'up' | 'down' | 'neutral' | 'none'

/* the change against the previous period, e.g. '14.06' green, '-3.20' red, '0.00' grey, '' 'N/A' */
const props = withDefaults(
  defineProps<{
    /* the percentage as a string, e.g. '14.06' or '-3.20' */
    diff?: string
    /* adds an arrow, so the direction is not carried by colour alone */
    hasArrow?: boolean
  }>(),
  { diff: '', hasArrow: false }
)

const { t } = useI18n()

/* equal periods ('0.00') are no decline, so they are neutral rather than red */
const tone = computed<DiffTone>(() => {
  const value = Number.parseFloat(props.diff)
  if (Number.isNaN(value)) return 'none'
  if (value === 0) return 'neutral'
  return value > 0 ? 'up' : 'down'
})
</script>
